import axios from "axios";
import React, {useState} from "react";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Line,
} from "react-simple-maps";
import { getPointsEnRoute } from "../../../functions/Geo";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";
import {fetch as fetchAirport} from "../../../services/airports/useAirports";
import {useQueryClient} from "react-query";
import { useTheme } from "@material-ui/core";

const geoUrl =
  // "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json";
  "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";
  const getAirportData = async (airportCode, queryClient) => {
    // const apiSitePrefix = getApiSitePrefix();

    const airportData = await fetchAirport({queryClient, extraKeys:[airportCode], useCache: true}); // axios.get(`${apiSitePrefix}/airports/list/${airportCode}`);
    return airportData[0];
  }

const getBookingRoute = async (origin, destination, tripRoute, _onwardRoutes, queryClient) => {
  const onwardRoutes = {truck:[], flight:[], ..._onwardRoutes};
  const route = [];
  const addAirportToRoute = async (airportCode, transport) => {
    const airportData = await getAirportData(airportCode);
    route.push({airportCode, transport, long: airportData.longitude, lat: airportData.latitude});
  }
  const truckRoutes = onwardRoutes['truck'];
  const flightRoutes = onwardRoutes['flight'];
  const truckDestinations = (truckRoutes||[]).map((route)=>route.split('-')[1]);
  const flightDestinations = (flightRoutes||[]).map((route)=>route.split('-')[1]);
  const tripAirports = (tripRoute||`${origin}-${destination}`).split('-');
  const originPos = tripAirports.indexOf(origin);
  const routeFromOrigin = tripAirports.slice(originPos);
  const destinationPos = routeFromOrigin.indexOf(destination);
  if (destinationPos < 0) {
    if (flightDestinations.indexOf(destination) >= 0){
      const flightOrigin = truckRoutes[truckDestinations.indexOf(destination)].split('-')[0];
      const flightOriginPos = tripAirports.indexOf(flightOrigin);
      const trimmedRoute = routeFromOrigin.slice(0, flightOriginPos + 1);
      for (let i = 0; i < trimmedRoute.length; i++) {
        await addAirportToRoute(trimmedRoute[i], "PRIMARY");
      }
      await addAirportToRoute(destination, "FLIGHT");
    } else {
      if (truckDestinations.indexOf(destination) >= 0){
        const truckOrigin = truckRoutes[truckDestinations.indexOf(destination)].split('-')[0];
        const truckOriginPos = tripAirports.indexOf(truckOrigin);
        if (truckOriginPos < 0) {
          const flightOrigin = truckRoutes[truckDestinations.indexOf(truckOrigin)].split('-')[0];
          const flightOriginPos = tripAirports.indexOf(flightOrigin);
          const trimmedRoute = routeFromOrigin.slice(0, flightOriginPos + 1);
          for (let i = 0; i < trimmedRoute.length; i++) {
            await addAirportToRoute(trimmedRoute[i], "PRIMARY");
          }
          await addAirportToRoute(truckOrigin, "FLIGHT");
          await addAirportToRoute(destination, "TRUCK");
        } else {
          const trimmedRoute = routeFromOrigin.slice(0, truckOriginPos + 1);
          for (let i = 0; i < trimmedRoute.length; i++) {
            await addAirportToRoute(trimmedRoute[i], "PRIMARY");
          }
          await addAirportToRoute(destination, "TRUCK");
        }
      }
    }
  } else {
    const trimmedRoute = routeFromOrigin.slice(0, destinationPos + 1);
    for (let i = 0; i < trimmedRoute.length; i++) {
      await addAirportToRoute(trimmedRoute[i], "PRIMARY");
    }
  }
  return route;
}

const FlightsMapContainer = (props) => {
  const record = props.record;
  const theme = useTheme();

  const [state, setState] = useState({
    markers: [],
    route: [],
    bookingUUid: null,
    flownRoute: [],
    aircraft: {coordinates: [], bearing: 0, angle: 0},
    projectionConfig: {
      scale: 180,
      rotation: [0,0,0]
    }
  });

  const queryClient = useQueryClient();

  if (state.bookingUuid !== record.bookingUuid) {

    getBookingRoute(record.origin, record.destination, record.tripRoute, record.onwardRoutes, queryClient).then(
      (route)=> {
        if (!route || route.length < 1) {
          setState({...state, markers: [], route: [], flownRoute: [], bookingUuid: record.bookingUuid, aircraft: null});
          return;
        };
        const markers = [];
        let smallestLat = null;
        let smallestLong = null;
        let biggestLat = null;
        let biggestLong = null;
        for (let i = 0; i < route.length; i++ ){
          markers.push( { name: route[i].airportCode, coordinates: [route[i].long, route[i].lat] });
          if (smallestLat === null || route[i].lat < smallestLat) smallestLat = route[i].lat;
          if (biggestLat === null || route[i].lat > biggestLat) biggestLat = route[i].lat;
          if (smallestLong === null || route[i].long < smallestLong) smallestLong = route[i].long;
          if (biggestLong === null || route[i].long > biggestLong) biggestLong = route[i].long;
        }
        const routePoints = [];
        const flownPoints = [];
        let aircraft = {coordinates:[route[0].long, route[0].lat], bearing: 0, angle: 0};
        for (let i = 1; i < route.length; i++ ){
          const aircraftPoints = getPointsEnRoute(route[i-1], route[i], 1000);
          const points = aircraftPoints.map((data)=> [data.long, data.lat]);
          if (i < Math.floor(route.length / 2)) {flownPoints.push(points)}
          if (i === Math.floor(route.length / 2)) {
            flownPoints.push(points.slice(0, Math.floor(points.length/2)));
            const lastPointFlown = aircraftPoints[Math.floor(aircraftPoints.length/2)];
            aircraft = {coordinates: [lastPointFlown.long, lastPointFlown.lat], ...lastPointFlown};
          }
          routePoints.push(points);
        }
// console.log(smallestLong, biggestLong, smallestLat, biggestLat);

        const projectionConfig = {
          scale: 450 - Math.max(350/360 * (biggestLat - smallestLat),350/180 * (biggestLong - smallestLong)),
//          rotation: [0,0,0],
          center: [(biggestLong + smallestLong)/2, (biggestLat + smallestLat)/2]
        }
        setState({...state, markers, route: routePoints, flownRoute: flownPoints, bookingUuid: record.bookingUuid, aircraft, projectionConfig});
        if (props.routeListener) {
          props.routeListener(route);
        }
      }
    );
  }

  return (
    <ComposableMap
      width={1000}
      height={540}
      projection="geoMercator"
      projectionConfig={state.projectionConfig}
    >
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies
            .map(geo => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#DADADA"
                stroke="#B0B0B0"
              />
            ))
        }
      </Geographies>
      {(state.route||[]).map((points) => (
        <Line
          coordinates={points}
          stroke="#000000"
          strokeWidth={1}
          strokeDasharray={[5, 5]}
        />
      ))}
      {(state.flownRoute||[]).map((points) => (
        <Line
          coordinates={points}
          stroke="#ff0000"
          strokeWidth={1}
        />
      ))}
      {state.markers.map(({ name, coordinates, markerOffset }) => (
        <Marker key={name} coordinates={coordinates}>
          <g
            fill="#303030"
            stroke="#000000"
            transform="translate(-4, -15) matrix(0.35,0,0,0.35,0,0)"
          >
            <path d="M3.005,2.673L2.855,2.673C2.774,2.673 2.708,2.607 2.708,2.526L2.708,2.232C2.708,2.15 2.774,2.084 2.855,2.084L8.579,2.084C8.741,1.469 9.597,1.011 10.621,1.011C11.646,1.011 12.501,1.469 12.663,2.084L18.387,2.084C18.468,2.084 18.534,2.15 18.534,2.232L18.534,2.526C18.534,2.607 18.468,2.673 18.387,2.673L18.237,2.673L17.242,9.235L17.003,9.235L17.003,10.117L20.912,10.117C21.004,10.117 21.079,10.192 21.079,10.284L21.079,10.619C21.079,10.711 21.004,10.786 20.912,10.786L20.833,10.786L19.251,18.166L19.299,18.166C19.392,18.166 19.466,18.241 19.466,18.333L19.466,18.668C19.466,18.76 19.392,18.835 19.299,18.835L14.677,18.835L14.677,40.62L6.565,40.62L6.565,18.835L1.943,18.835C1.851,18.835 1.776,18.76 1.776,18.668L1.776,18.333C1.776,18.241 1.851,18.166 1.943,18.166L1.98,18.166L0.409,10.786L0.33,10.786C0.238,10.786 0.163,10.711 0.163,10.619L0.163,10.284C0.163,10.192 0.238,10.117 0.33,10.117L4.239,10.117L4.239,9.235L4,9.235L3.005,2.673ZM16.239,9.235L15.003,9.235L15.003,10.117L16.239,10.117L16.239,9.235ZM14.239,9.235L13.003,9.235L13.003,10.117L14.239,10.117L14.239,9.235ZM12.239,9.235L11.003,9.235L11.003,10.117L12.239,10.117L12.239,9.235ZM10.239,9.235L9.003,9.235L9.003,10.117L10.239,10.117L10.239,9.235ZM8.239,9.235L7.003,9.235L7.003,10.117L8.239,10.117L8.239,9.235ZM6.239,9.235L5.003,9.235L5.003,10.117L6.239,10.117L6.239,9.235ZM6.084,6.002L4.268,6.002L4.624,8.252L6.266,8.252L6.084,6.002ZM10.395,6.002L8.796,6.002L8.851,8.252L10.395,8.252L10.395,6.002ZM12.528,6.002L12.466,8.252L10.844,8.243L10.844,6.002L12.528,6.002ZM14.637,6.002L14.449,8.252L13.015,8.243L13.069,6.002L14.637,6.002ZM8.218,6.002L6.638,6.002L6.824,8.252L8.266,8.252L8.218,6.002ZM17.012,6.002L16.657,8.243L15.015,8.243L15.199,6.002L17.012,6.002ZM6.038,5.432L5.847,3.068L3.803,3.068L4.177,5.432L6.038,5.432ZM8.206,5.432L8.155,3.068L6.395,3.068L6.591,5.432L8.206,5.432ZM8.782,5.432L10.395,5.432L10.395,3.068L8.724,3.059L8.782,5.432ZM10.844,5.432L10.844,3.059L12.609,3.068L12.544,5.432L10.844,5.432ZM13.082,5.432L13.139,3.059L14.881,3.068L14.684,5.432L13.082,5.432ZM17.103,5.432L15.246,5.432L15.441,3.059L17.479,3.059L17.103,5.432Z"/>
          </g>
          <text
            textAnchor="middle"

            x={0}
            y={8}
            style={{ fontSize: 10, fontFamily: "system-ui", fill: "#5D5A6D" }}
          >
            {name}
          </text>
        </Marker>
      ))}
      {state.aircraft ?
        <Marker
          key="aircraft"
          coordinates={state.aircraft.coordinates}
        >
          <g
            fill = {theme.palette.primary.main}
            transform={`rotate(${state.aircraft.bearing}), translate(-10, -10) matrix(0.127679,-0.127679,0.127,0.127,-2.75098,12.1833)`}
          >
            <path d="M83.768,23.581L78.58,28.77L80.766,44.37L83.699,41.437C84.145,40.991 84.874,40.991 85.32,41.437L87.42,43.536C87.864,43.982 87.864,44.712 87.42,45.158L81.682,50.895L83.558,64.267L86.793,61.032C87.239,60.587 87.968,60.587 88.414,61.032L90.514,63.132C90.958,63.577 90.958,64.307 90.514,64.752L84.473,70.793L86.913,88.2C87.206,90.296 86.478,92.21 84.981,93.706L83.442,95.247L61.876,45.473L47.219,60.131C44.568,62.78 41.31,65.173 37.87,67.419L40.557,85.721C40.888,87.973 40.199,90.053 38.59,91.661L37.677,92.574L28.161,73.4C26.546,74.386 24.978,75.362 23.505,76.343C24.485,74.857 25.462,73.274 26.446,71.64L7.185,62.08L8.097,61.167C9.706,59.56 11.786,58.87 14.037,59.2L32.398,61.896C34.575,58.552 36.893,55.391 39.467,52.819L54.21,38.077L4.915,16.72L6.456,15.179C7.952,13.682 9.867,12.955 11.963,13.249L29.369,15.689L35.41,9.648C35.856,9.202 36.585,9.202 37.03,9.648L39.13,11.747C39.575,12.192 39.575,12.921 39.13,13.367L35.895,16.604L49.267,18.479L55.005,12.742C55.45,12.297 56.18,12.297 56.625,12.742L58.725,14.842C59.17,15.287 59.17,16.016 58.725,16.462L55.791,19.395L70.791,21.498L73.1,19.188C74.051,18.118 75.067,17.036 76.145,15.958C84.027,8.073 92.127,3.389 94.23,5.495C96.337,7.6 91.651,15.697 83.768,23.581Z"/>
          </g>
        </Marker>
      : <></>
      }
    </ComposableMap>
  );
};

export default FlightsMapContainer
